
import { Component, Prop, Vue } from 'vue-property-decorator';
import ReasonSelect from './ReasonSelect.vue';
import StandardModal from '@/components/shared/suites/StandardModal.vue';

@Component<DeclineOrderModal>({
	components: {
		ReasonSelect,
		StandardModal
	}
})
export default class DeclineOrderModal extends Vue {
	@Prop({ type: Boolean, required: true }) private loading!: boolean;

	private reasonsList: string[] = [
		'unavailable',
		'special_request',
		'delivery',
		'limit_exceeded',
		'other'
	];
	private reason: { value: string; note: string; } = { value: '', note: '' };

	/**
	 * Emit to decline the order with the selected cancellation note.
	 *
	 * @return {void}
	 */
	private declineOrder(): void {
		this.$emit('decline-order', this.reason.note);
	}
}
